<template>
	<div class="visual-controls">
		<speaker-notes :notes="currentNotes"></speaker-notes>
		<h2>Implementation - Visual Controls</h2>
		<flow-chart selected="controls"></flow-chart>
		<div class="abcjs-xlarge">
		<div class="abcjs-inline-audio">
			<button type="button" :class="buttonClass" title="Click to play/pause." aria-label="Click to play/pause."><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25" class="abcjs-play-svg">
				<g>
					<polygon points="4 0 23 12.5 4 25"></polygon>
				</g>
			</svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25" class="abcjs-pause-svg">
				<g>
					<rect width="8.23" height="25"></rect>
					<rect width="8.23" height="25" x="17"></rect>
				</g>
			</svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" class="abcjs-loading-svg">
				<circle cx="50" cy="50" fill="none" stroke-width="20" r="35" stroke-dasharray="160 55"></circle>
			</svg></button>
			<button type="button" class="abcjs-midi-progress-background" title="Click to change the playback position." aria-label="Click to change the playback position."><span class="abcjs-midi-progress-indicator" style="left: 0px;"></span></button>
			<span class="abcjs-midi-clock">0:00</span>
		</div>
		</div>

		<div :class="arrowClass">
			<img src="@/assets/images/arrow-up.png" alt="arrow to visual control"/>
		</div>
		<code v-if="part === 1" class="p1">
			&lt;svg viewBox="0 0 25 25" class="play-svg"&gt;<br>
			<span class="indent1"><span class="b1">&lt;polygon points="4 0 23 12.5 4 25"&gt;&lt;/polygon&gt;</span></span>>
&lt;/svg&gt;
		</code>

		<code v-if="part === 2" class="p2">
&lt;svg viewBox="0 0 25 25" class="pause-svg"&gt;<br>
<span class="indent1"><span class="b2">&lt;rect width="8.23" height="25"&gt;&lt;/rect&gt;</span></span>
<span class="indent1"><span class="b2">&lt;rect width="8.23" height="25" x="17"&gt;&lt;/rect&gt;</span></span>
&lt;/svg&gt;
		</code>

		<code v-if="part === 3" class="p3">
&lt;svg viewBox="0 0 100 100" class="loading-svg"&gt;<br>
			<span class="indent1"><span class="b3">&lt;circle cx="50" cy="50" fill="none" stroke-width="20"</span></span>&nbsp;&nbsp;
				<span class="indent1"><span class="b3">r="35" stroke-dasharray="160 55"&gt;&lt;/circle&gt;</span></span>
&lt;/svg&gt;
		</code>

		<code v-if="part === 4" class="p4">
			&lt;<span class="b4">button</span> class="midi-progress-background"&gt;
			<span class="indent1">&lt;<span class="b4">span</span> class="midi-progress-indicator"&gt;&lt;/span&gt;</span>
&lt;/button&gt;
		</code>

	</div>
</template>

<script>
	import PageParts from "../helpers/page-parts";
	import FlowChart from "../components/FlowChart";
	import SpeakerNotes from "../components/SpeakerNotes";
	export default {
		name: "visual-controls",
		components: {SpeakerNotes, FlowChart},
		mixins: [
			PageParts,
		],
		computed: {
			buttonClass() {
				const cls = "abcjs-midi-start abcjs-btn ";
				switch (this.part) {
					case 2:
						return cls + "abcjs-pushed";
					case 3:
						return cls + "abcjs-loading";
					default:
						return cls;
				}
			},
			arrowClass() {
				return `arrow p${this.part}`;
			}
		},
		data() {
			return {
				notes: [
					[
						"Surprised by how simple it was to draw the controls and style them.",
						"First, we have a button that can have three things in it: a play button,",
						"That polygon is a triangle.",
					],
					[
						"A pause button. Those are two straight lines.",
					],
					[
						"A progress indicator. This is part of a circle that we'll animate.",
					],
					[
						"Then we draw a long rectangle for the progress indicator.",
						"Inside of that is the thumb that will move.",
					],
				]
			};
		},
	}
</script>

<style lang="scss" scoped>
	.visual-controls {
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	.abcjs-xlarge {
		width: 190px;

		.abcjs-inline-audio {
			margin-left: 0;
		}
	}

	.arrow {
		margin-top: 10px;
		width: 190px;

		&.p1, &.p2, &.p3 {
			padding-left: 10px;
		}
		&.p4 {
			padding-left: 80px;
		}
	}

	@media screen and (min-width: 500px) {
		.abcjs-xlarge, .arrow {
			width: 430px;
		}
	}

	@media screen and (min-width: 750px) {
		.abcjs-xlarge, .arrow {
			width: 670px;
		}

		.arrow {
			&.p1, &.p2, &.p3 {
				padding-left: 70px;
			}
			&.p4 {
				padding-left: 220px;
			}
		}
	}

	@media screen and (min-width: 1170px) {
		.abcjs-xlarge, .arrow {
			width: 1150px;
		}
	}
</style>
